var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconReset(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 3.8125L10.3536 4.16605L10.7071 3.8125L10.3536 3.45895L10 3.8125ZM7.1875 10.5C7.46364 10.5 7.6875 10.2761 7.6875 10C7.6875 9.72386 7.46364 9.5 7.1875 9.5L7.1875 10.5ZM7.54105 6.97855L10.3536 4.16605L9.64645 3.45895L6.83395 6.27145L7.54105 6.97855ZM10.3536 3.45895L7.54105 0.646446L6.83395 1.35355L9.64645 4.16605L10.3536 3.45895ZM10 3.3125L4.09375 3.3125L4.09375 4.3125L10 4.3125L10 3.3125ZM4.09375 10.5L7.1875 10.5L7.1875 9.5L4.09375 9.5L4.09375 10.5ZM0.5 6.90625C0.5 8.89102 2.10898 10.5 4.09375 10.5L4.09375 9.5C2.66126 9.5 1.5 8.33874 1.5 6.90625L0.5 6.90625ZM4.09375 3.3125C2.10898 3.3125 0.5 4.92148 0.5 6.90625L1.5 6.90625C1.5 5.47376 2.66126 4.3125 4.09375 4.3125L4.09375 3.3125Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconReset);
export default __webpack_public_path__ + "static/media/icon_reset.2d37ca28bed44c108b24f7e9088288d7.svg";
export { ForwardRef as ReactComponent };